import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DictionaryClientDataRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';

import { isNotEmpty } from 'src/app/extensions/utilities';
import { ClientDataRequestTypeEnum } from 'src/app/models/ClientDataEnums';
import { FilesHandler } from '../utils/files-handler';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'app-add-client-data-request',
  templateUrl: './add-client-data-request.component.html',
  styleUrls: ['./add-client-data-request.component.scss'],
  standalone: false,
})
export class AddClientDataRequestComponent implements OnInit {
  requestTypes: app.models.ClientDataRequestType[] = [];
  requestTypesProps: app.models.DynamicPropsDictionary;
  requestTypeCodes = ClientDataRequestTypeEnum;
  isPJ: boolean;

  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel = {
    documentsAttached: [],
    otherField: '',
    ibanField: '',
    bankName: '',
  } as app.models.ClientDataRequestSaveModel;
  isSendButtonDisabled: boolean = false;

  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _dictionaryService: DictionaryAPIService,
    private _partnerService: PartnerAPIService,
    public _filesHandler: FilesHandler,
    private _activatedRoute: ActivatedRoute
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      if (isNotEmpty(this.stateSignalItem.data.otherField)) {
        this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
        this.isSendButtonDisabled = this.stateSignalItem.extras?.isSendButtonDisabled ?? this.isSendButtonDisabled;
      } else {
        this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, undefined);
      }
    }
  }

  ngOnInit(): void {
    let source = forkJoin([this._dictionaryService.getClientDataRequestTypes(), this._partnerService.getCompanyInfo()]);
    source.subscribe(([typesData, companyData]) => {
      if (companyData.data) {
        this.isPJ = companyData.data.isPJ;
        this.clientDataRequestSaveModel.partnerExternalEntityId = companyData.data.partnerExternalEntityId;
      }
      this.requestTypes = typesData.data;
      this.requestTypesProps = typesData.props;
    });
  }

  redirectListHandler = () => {
    this._router.navigate(['requests/client-data']);
  };

  clientDataRequestTypeChangedHandler() {
    let type = this.requestTypes.find(x => x.id == this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId);
    if (type) {
      this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeCode = type.code;
      this.clientDataRequestSaveModel.description = type.description;
      this.isSendButtonDisabled = false;
      if (type.code == DictionaryClientDataRequestType.Other) {
        this.isSendButtonDisabled = !isNotEmpty(this.clientDataRequestSaveModel.otherField);
      }
      if (type.code == DictionaryClientDataRequestType.BankAccount) {
        this.isSendButtonDisabled =
          !isNotEmpty(this.clientDataRequestSaveModel.ibanField) ||
          !isNotEmpty(this.clientDataRequestSaveModel.bankName);
      }
    }
    this.clientDataRequestSaveModel.otherField = '';
  }

  textAreaInputHandler() {
    this.isSendButtonDisabled = !isNotEmpty(this.clientDataRequestSaveModel.otherField);
  }

  bankAccountInputHandler() {
    this.isSendButtonDisabled =
      !isNotEmpty(this.clientDataRequestSaveModel.ibanField) || !isNotEmpty(this.clientDataRequestSaveModel.bankName);
  }

  redirectSelectionHandler() {
    let route: string;
    let dictionaryClientDataRequestType = this.requestTypes.find(
      x => x.id == this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId
    );

    if (dictionaryClientDataRequestType) {
      this.stateSignalItem = undefined;

      if (
        dictionaryClientDataRequestType.code == ClientDataRequestTypeEnum.Other &&
        isNotEmpty(this.clientDataRequestSaveModel.otherField)
      ) {
        this.stateSignalItem = {
          data: this.clientDataRequestSaveModel,
          extras: {
            isPJ: this.isPJ,
            isSendButtonDisabled: this.isSendButtonDisabled,
          },
          routePath: this._activatedRoute.snapshot.routeConfig.path,
        };
        route = 'requests/client-data/new/request-preview';
      }

      if (
        dictionaryClientDataRequestType.code == ClientDataRequestTypeEnum.BankAccount &&
        isNotEmpty(this.clientDataRequestSaveModel.ibanField) &&
        isNotEmpty(this.clientDataRequestSaveModel.bankName)
      ) {
        this.stateSignalItem = {
          data: this.clientDataRequestSaveModel,
          extras: {
            isPJ: this.isPJ,
            isSendButtonDisabled: this.isSendButtonDisabled,
          },
          routePath: this._activatedRoute.snapshot.routeConfig.path,
        };
        route = 'requests/client-data/new/request-preview';
      }

      switch (dictionaryClientDataRequestType.code) {
        case ClientDataRequestTypeEnum.CompanyInfo: {
          route = 'requests/client-data/new/personal-information-request';
          break;
        }
        case ClientDataRequestTypeEnum.PersonalInfo: {
          route = 'requests/client-data/new/personal-information-request';
          break;
        }
        case ClientDataRequestTypeEnum.ContactInfo: {
          route = 'requests/client-data/new/contact-information-request';
          break;
        }
        case ClientDataRequestTypeEnum.Address: {
          route = 'requests/client-data/new/address-information-request';
          break;
        }
        case ClientDataRequestTypeEnum.Associates: {
          route = 'requests/client-data/new/associates-information-request';
          break;
        }
        case ClientDataRequestTypeEnum.Legal: {
          route = 'requests/client-data/new/legal-information-request';
          break;
        }
        case ClientDataRequestTypeEnum.Owner: {
          route = 'requests/client-data/new/owner-information-request';
          break;
        }
      }

      this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, this.stateSignalItem);
      this._router.navigate([route]);
    }
  }
}
